import ExploreVenues from './pages/ExploreVenues'
import Button from '../../../../components/ui/Button'
// import TopSportsComplexes from '../../components/TopSportsComplexes'
const Book = () => {
  return (
    <>
    <ExploreVenues/>
    <Button>
      Show More
    </Button>
    {/* <TopSportsComplexes/> */}
    </>
  )
}

export default Book